"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessage = exports.system = exports.resources = exports.logging = exports.files = exports.auth = exports.activity = void 0;
const tslib_1 = require("tslib");
const setup_1 = require("./setup");
const port_1 = require("./messages/port");
Object.defineProperty(exports, "sendMessage", { enumerable: true, get: function () { return port_1.sendMessage; } });
const activity_1 = tslib_1.__importDefault(require("./namespaces/activity"));
exports.activity = activity_1.default;
const auth_1 = tslib_1.__importDefault(require("./namespaces/auth"));
exports.auth = auth_1.default;
const system_1 = tslib_1.__importDefault(require("./namespaces/system"));
exports.system = system_1.default;
const logging_1 = tslib_1.__importDefault(require("./namespaces/logging"));
exports.logging = logging_1.default;
const files_1 = tslib_1.__importDefault(require("./namespaces/files"));
exports.files = files_1.default;
const resources_1 = tslib_1.__importDefault(require("./namespaces/resources"));
exports.resources = resources_1.default;
(0, setup_1.init)();
tslib_1.__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map